












import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import BGMSound from "@/media/BGMSound";
import AppEvent from "@/events/AppEvent";
import { Sweep } from "@/params/Sweep";
import { WindowVisibilityChecker, WindowVisibilityEvent } from "@/libs/WindowVisibilityChecker";

@Component({
  computed: mapState([ 'isBgmMuted', 'isBgmPlaying' ])
})
export default class BgmController extends Vue {
  /* Data */
  // mapState: isBgmMuted
  private isBgmMuted: boolean;
  private isBgmPlaying: boolean;
  private soundList: BGMSound[] = [];
  private soundParams = [
    {
      type: 'bgm',
      label: 'BGM1',
      src: '/sounds/bgm2.mp3',
      basisVolume: 0.175,
      limitDistance: 40,
      attenuate: 0.3,
      sweep: {
        uuid: '23c915990eb24dd2b844252ec340d248',
        floor: 0,
        position: {
          x: -35.97908020019531,
          y: 1.3066973686218262,
          z: 3.2892582416534424
        }
      }
    },
    {
      type: 'bgm',
      label: 'BGM2',
      src: '/sounds/bgm2.mp3',
      basisVolume: 0.175,
      limitDistance: 35,
      attenuate: 0.3,
      sweep: {
        uuid: '59cc808ed3e8486da7c0e026912c2365',
        floor: 1,
        position: {
          x: -5.76215124130249,
          y: 6.404370307922363,
          z: 6.543001174926758
        }
      }
    }
  ];
  private windowVisibility: WindowVisibilityChecker;

  /* Property */
  @Prop() currentSweep: Sweep = null;

  /* Watcher */
  @Watch('currentSweep')
  onUpdateCurrentSweep (newValue: Sweep, oldValue: Sweep): void {
    if (!newValue) { return; }
    if (newValue != oldValue) {
      // console.log('Update Sweep: ', newValue);
      this.updateBgm();
    }
  }

  @Watch('isBgmMuted')
  onChangeMuted (newValue, oldValue): void {

  }

  @Watch( 'isBgmPlaying' )
  onChangePlaying (newValue, oldValue): void {
    if (newValue !== oldValue) {
      if (newValue) {
        this.playBgm();
        if (!this.windowVisibility) {
          this.windowVisibility = new WindowVisibilityChecker();
          this.windowVisibility.enableCheck();
        }
        this.windowVisibility.addEventListener(WindowVisibilityEvent.HIDDEN, this.onWindowHide);
        this.windowVisibility.addEventListener(WindowVisibilityEvent.VISIBLE, this.onWindowVisible);
      }
      else {
        this.pauseBgm();
        this.windowVisibility.removeAllEventListeners();
      }
    }
  }

  /* Computed Property */
  get publicPath (): string {
    return this.$store.state.publicPath;
  }

  get isSmp (): boolean {
    return this.$store.state.isSmp;
  }

  mounted (): void {
    this.$nextTick(async () => {
      this.soundParams.forEach(soundParam => {
        const sound = new BGMSound(soundParam.type, soundParam.label, this.publicPath + soundParam.src, soundParam.sweep, soundParam.basisVolume, soundParam.limitDistance, soundParam.attenuate);
        this.soundList.push(sound);
      });

      const soundAmount = this.soundList.length;
      console.log('Amount: ' + soundAmount);

      for (let i = 0; i < soundAmount; i++) {
        const bgm = this.soundList[i];
        bgm.addEventListener(AppEvent.LOAD_COMPLETE, this.onLoadCompleteBgm);
        bgm.load();
      }
    });
  }


  /**
   * すべてのBGMを再生する
   */
  public playBgm (): void {
    console.log('Play BGM');
    this.soundList.forEach((sound) => {
      if (sound.type === 'bgm') {
        sound.play();
      }
    });
  }

  /**
   * すべてのBGMを一時停止する
   */
  public pauseBgm (): void {
    console.log('Pause BGM');
    this.soundList.forEach((sound) => {
      if (sound.type === 'bgm') {
        sound.pause();
      }
    });
  }

  /**
   * すべてのBGMをリセットする
   * @param ev
   */
  public reset(): void {
    console.log('BGM Controller Reset');
    this.soundList.forEach((sound) => {
      sound.stop();
    });
    this.$store.commit('resetBgm');
    this.windowVisibility.disEnableCheck();
    this.windowVisibility.removeAllEventListeners();
  }


  protected onLoadCompleteBgm (ev: Event): void {
    ev.target.removeEventListener(AppEvent.LOAD_COMPLETE, this.onLoadCompleteBgm);

    //　すべてのサウンドのロードが完了していたらLOAD_COMPLETEイベント発火する
    let allLoaded: boolean = true;
    this.soundList.forEach((sound) => {
      if (!sound.isLoaded) {
        allLoaded = false;
      }
    });

    if (allLoaded) {
      this.$emit(AppEvent.LOAD_COMPLETE);
      console.log('LoadComplete');
    }
  };


  protected toggleBgm (): void {
    // console.log('ToggleBGM: ' + this.isMuteBgm);
    // 現在ミュート状態であればミュートを解除する
    if (this.isBgmMuted) {
      this.$store.commit('toggleBgm', { toggle: true });
    }
    else {
      this.$store.commit( 'toggleBgm', { toggle: false });
    }
  }


  protected updateBgm (): void {
    // すべてのBGMに対して、現在値との距離から音量を設定する
    this.soundList.forEach((sound) => {
      const distance = Math.sqrt(Math.pow(sound.sweep.position.x - this.currentSweep.position.x, 2) + Math.pow(sound.sweep.position.z - this.currentSweep.position.z, 2));
      // 階の差の分、差を大きくする
      const floorDiff = Math.abs(sound.sweep.floor - this.currentSweep.floor);
      let elevation = Math.abs(sound.sweep.position.y - this.currentSweep.position.y) * (floorDiff + 1);
      elevation = elevation < 1 ? 0 : elevation;
      sound.setDistance(distance, elevation);
    });
  }

  protected onWindowHide (ev: WindowVisibilityEvent): void {
    console.log('Windowが非アクティブになった');
    if (this.isBgmPlaying) {
      this.pauseBgm();
    }
  }

  protected onWindowVisible (ev: WindowVisibilityEvent): void {
    console.log('Windowがアクティブになった');
    if (this.isBgmPlaying) {
      this.playBgm();
    }
  }
}
